import React, { useContext, useState } from 'react'
import ProductPlanCard from './planCard'
import { useNavigate } from 'react-router-dom'
import { COLORS } from '../../../resources/colors-contants'
import { useMyContext } from '../context'
import { jwtDecode } from 'jwt-decode'

interface wrapperProp {
    amount?: any | number
    yearOrMonth?: string
    cardMarginTop?: string
}

interface MyJwtPayload {
    verification_status: any
}
const ProductPlanCardWrapper: React.FC<wrapperProp> = ({ amount, yearOrMonth, cardMarginTop }) => {

    const { myData, loading } = useMyContext()
    const navigate = useNavigate();
    const [token] = useState<string | null>(localStorage.getItem('token'));
    let decoded: MyJwtPayload | null = null;
                                    
    if (token && token !== '') {
        decoded = jwtDecode<MyJwtPayload>(token);
      }
    const headers = Array.isArray(myData?.headers) ? myData.headers : []
    if (!headers[1] || !headers[2]) {
        return null
    }
    // const d = `${headers[1]?.discount}-${headers[1]?.amountYear}`;
    const dat: {
        id: number
        title: string
        description: string
        priceText: any
        backgroundColor: string
        perYear: boolean
        btnBackgroundColor: string
        duration: string
        discount: string
        btnColor: string
        btnText: string
        cardBorderColor: string
        action: string
        data: { text: string }[]
        style: React.CSSProperties
        displayCheckIcon?: boolean
        disabled?: boolean
         // Specify the type explicitly
        // ₦${myData ? headers[0].amountYear
    }[] = [
        // {
        //     id: headers[0].id,
        //     title: myData ? headers[0].name : 'Basic',
        //     description: 'Obtain the essentials for daily operations and services, then pay just when you want to switch to a different plan.',
        //     // priceText: `${amount !== '' ? '₦' + amount : `₦${myData ? new Intl.NumberFormat().format(headers[1]?.amountYear * headers[1]?.discount) : ''}`}`,
        //     priceText: `₦${myData ? headers[0].amountYear : '0'}.00`,
        //     backgroundColor: COLORS.white_color,
        //     perYear: false,
        //     duration: yearOrMonth === 'yearly' ? 'year' : 'month',
        //     discount: '',
        //     btnBackgroundColor: COLORS.white_color,
        //     btnColor: COLORS.primary_background,
        //     btnText: 'Get started',
        //     cardBorderColor: '1px solid #CFD1D3',
        //     action: `/download`,
        //     // action: `/plans-details/${headers[0].id}/${yearOrMonth}`,
        //     data: [
        //         { text: 'Enjoy advance level inventory management system' },
        //         { text: 'Track payment and purchases of unlimited customers.' },
        //         { text: 'Manage unlimited bank accounts & track bank transactions with ease.' }
        //     ],
        //     style: {
        //         backgroundColor: COLORS.white_color,
        //         // margin: '13px',
        //         paddingLeft: '20px',
        //         paddingRight: '20px',
        //         paddingTop: '40px',
        //         paddingBottom: '40px',
        //         boxSizing: 'border-box',
        //         borderRadius: '10px',
        //         border: '1px solid #CFD1D3',
        //         position: 'relative',
        //         // width: 499,
        //     }
        // },
        {   id: headers[1].id,
            title: myData ? headers[1].name : 'Plus',
            description: 'Obtain the essentials for daily operations and services, then pay just when you want to switch to a different plan.',
            priceText:  `${yearOrMonth === 'yearly' ? `₦${myData ? `${new Intl.NumberFormat().format(headers[1]?.amountYear * headers[1]?.discount/100)}` : headers[1]?.amountMonth }` : `${new Intl.NumberFormat().format(headers[1]?.amountMonth)}`}`,
            backgroundColor: COLORS.plan_blue,
            perYear: true,
            duration: yearOrMonth === 'yearly' ? 'year' : 'month',
            // discount: `${new Intl.NumberFormat().format(headers[0]?.amountYear)}`,
            discount: `${yearOrMonth === 'yearly' ? `₦${myData ? `${new Intl.NumberFormat().format(headers[1]?.amountYear)}` : ''}` : ''}`,
            btnBackgroundColor: COLORS.primary_background,
            btnColor: COLORS.white_color,
            btnText: token && decoded?.verification_status === 0 ? 'On trial/Subscription' : 'Try free for 7 days',
            disabled: token && decoded?.verification_status === 0 ? true : false,
            cardBorderColor: 'none',
            action: `/plans-details/${headers[1].id}/${yearOrMonth}`,
            data: [
                { text: 'Enjoy advance level inventory management system' },
                { text: 'Track payment and purchases of unlimited customers.' },
                { text: 'Manage unlimited bank accounts & track bank transactions with ease.' }
            ],
            style: {
                // flex: 1,
                backgroundColor: COLORS.plan_blue,
                // margin: '13px',
                paddingLeft: '20px',
                paddingRight: '20px',
                paddingTop: '40px',
                paddingBottom: '40px',
                // boxSizing: 'border-box',
                borderRadius: '10px',
                border: '1px solid #E6EBF5',
                position: 'relative',
                // width: 499
            }
        },
        {   id: headers[2].id,
            title: myData ? headers[2]?.name : 'Enterprise',
            description:
                'Get the optimal price structure for your typical transaction size, payment volume, and other business requirements by partnering with us.',
            priceText: 'Personalise pricing',
            backgroundColor: COLORS.white_color,
            perYear: false,
            duration: '',
            discount: '',
            btnBackgroundColor: COLORS.white_color,
            btnColor: COLORS.primary_background,
            btnText: 'Contact sales',
            cardBorderColor: '1px solid #CFD1D3',
            action: '/contact',
            data: [
                { text: 'Contact sales to get your customized pricing that suits your business.' }
                // { text: 'Track payment and purchases of unlimited customers.' },
                // { text: 'Manage unlimited bank accounts & track bank transactions with ease.' }
            ],
            style: {
                backgroundColor: COLORS.white_color,
                // margin: '3px',
                paddingLeft: '20px',
                paddingRight: '20px',
                paddingTop: '40px',
                paddingBottom: '40px',
                boxSizing: 'border-box',
                borderRadius: '10px',
                border: '1px solid #CFD1D3',
                position: 'relative',
                // width: 499,
            }
        }
    ]

    return (
        <>
            <div className="d-none d-lg-block" style={{ marginTop: cardMarginTop || '2rem', }}>
                <div className="row justify-content-center m-0 p-0" >
                    {dat.map((val, index) => (
                        <div className={` col-12 col-lg-4 col-md-6 ${!dat[dat.length] ? 'mb-5' : ''} `} key={index} 
                       
                        >
                          <div className="card h-100 w-100"  style={val.style}>
                          <ProductPlanCard
                                title={val.title}
                                description={val.description}
                                priceText={val.priceText}
                                backgroundColor={val.backgroundColor}
                                perYear={val.perYear}
                                discount={val.discount}
                                duration={val.duration}
                                btnBackgroundColor={val.btnBackgroundColor}
                                btnColor={val.btnColor}
                                btnText={val.btnText}
                                cardBorderColor={val.cardBorderColor}
                                displayCheckIcon={true}
                                 disabled={token ? true : false}
                                purchaseAction={
                                    () => {
                                         if (token && decoded?.verification_status === 0) {
                                        navigate(val.action)
                                    }
                                    if (token && decoded?.verification_status === "1") {
                                        navigate(`/verify-phone?plan=${val.id}&duration=${yearOrMonth}`)
                                    }
                                    if (!token) {
                                        navigate(`/signup?plan=${val.id}&duration=${yearOrMonth}&page=signup`);
                                    }
                                    }
                                }
                                btnAction={() => {
                                   
                                    if (token && decoded?.verification_status === 0) {
                                        navigate(val.action)
                                    }
                                    if (token && decoded?.verification_status === "1") {
                                        navigate(`/verify-phone?plan=${val.id}&duration=${yearOrMonth}`)
                                    }
                                    if (!token) {
                                        navigate(`/signup?plan=${val.id}&duration=${yearOrMonth}&page=signup&onTrial=${true}`);
                                    }
                                   
                                    if (val.action === '/contact') {
                                        navigate(val.action);
                                    }
                                }}
                                
                                arr={val.data}
                                isStyled={true}
                            />
                          </div>
                        </div>
                    ))}
                </div>
            </div>
            
        </>
    )
}

export default ProductPlanCardWrapper
